import React from 'react';
import SirSlide from './sir-slide';
import Slide from './slide';

const SlideWrapper = (props) => {
  if (props.isSir) {
    return <SirSlide { ...props } />;
  } else {
    return <Slide { ...props } />;
  }
};

export default SlideWrapper;



// WEBPACK FOOTER //
// ./src/components/search/result/mini-slideshow/slide-wrapper.js